import { Component, Input } from '@angular/core';
@Component({
  selector: 'app-text-with-four-images',
  templateUrl: './text-with-four-images.component.html',
  styleUrls: ['./text-with-four-images.component.css'],
})
export class TextWithFourImagesComponent {
  @Input() data!:any;
  
}
